export default (editor, opts = {}) => {
    const COMPS = editor.DomComponents;
    const TYPE = COMPS.getType('label');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    COMPS.addType('label', {
        model: MODEL.extend({
            defaults: {
                ...MODEL.prototype.defaults,
            }
        }),
        view: VIEW.extend({
            tagName: "div",
            onRender() {
                this.el.style.display = "inline-block";
                let attr = this.model.getAttributes();

                // Si no tenemos un valor en el attributo for no continuamos con la ejecución
                if (!attr["for"]) return;
                let attrFor = attr["for"];

                let parent = this.model.parent();
                // Si no tenemos un componente padre que junte el label con el radio no continuamos con la ejecución
                if (!parent) return;
                let findChildComponentsTypeRadio = parent.findType("radio");

                // Si no hay componentes de tipo radio en el parent no continuamos la ejecución.
                if (findChildComponentsTypeRadio.length == 0) return;

                let closetRadioComponent = parent.findType("radio").at(0);

                // Si el attributo for no corresponde con le Id del compoente radio no se continua con la ejecución
                if (closetRadioComponent.getId() != attrFor) return;

                this.model.addTrait({
                    type: 'button',
                    text: 'Find "for" reference',
                    full: true, // Full width button
                    command: editor => {
                        editor.select(closetRadioComponent);
                    },
                });

            },
        })
    });

}
